// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uei_container {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    gap: 16px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.uei_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.uei_title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.uei_action_buttons {
    display: flex;
    gap: 8px;
}

.uei_edit_button,
.uei_confirm_button {
    background-color: var(--primary);
    padding: 7px 16px;
    border-radius: var(--radius-sm);
    border: none;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    transition: all var(--transition-fast);
}

.uei_edit_button:hover:not(:disabled),
.uei_confirm_button:hover:not(:disabled) {
    background-color: var(--primary-hover);
}

.uei_cancel_button {
    background-color: var(--bg);
    padding: 7px 16px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    color: var(--text-secondary);
    transition: all var(--transition-fast);
}

.uei_cancel_button:hover:not(:disabled) {
    background-color: var(--bg-card);
    border-color: var(--text-muted);
}

.uei_edit_button:disabled,
.uei_confirm_button:disabled,
.uei_cancel_button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.uei_fields_grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}

.uei_field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 10px 12px;
    background-color: var(--bg);
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
}

.uei_field_picture {
    grid-column: 1 / -1;
}

.uei_label {
    font-size: 12px;
    color: var(--text-muted);
    font-weight: 500;
}

.uei_value {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
}

.uei_input {
    width: 100%;
    padding: 6px 10px;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    font-size: 14px;
    font-weight: 600;
    background-color: var(--bg-card);
    color: var(--text-primary);
    box-sizing: border-box;
}

/* Picture upload — same style as UserSignalProvider */
.uei_picture_row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.uei_picture_preview {
    width: 72px;
    height: 72px;
    object-fit: cover;
    border-radius: 50%;
    border: 1px solid var(--border);
}

.uei_picture_button {
    padding: 6px 14px;
    border-radius: var(--radius-sm);
    border: 1px dashed var(--border);
    background-color: var(--bg-card);
    color: var(--text-secondary);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all var(--transition-fast);
}

.uei_picture_button:hover {
    border-color: var(--primary);
    color: var(--primary);
    background-color: var(--bg-card);
}

.uei_picture_filename {
    font-size: 12px;
    color: var(--text-muted);
    font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/pages/users/userById/UserSections/UserEditInfos/userEditInfos.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;;IAEI,gCAAgC;IAChC,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;;IAEI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;;;IAGI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,2BAA2B;IAC3B,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA,sDAAsD;AACtD;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,gCAAgC;IAChC,gCAAgC;IAChC,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,kBAAkB;AACtB","sourcesContent":[".uei_container {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    gap: 16px;\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.uei_header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.uei_title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.uei_action_buttons {\n    display: flex;\n    gap: 8px;\n}\n\n.uei_edit_button,\n.uei_confirm_button {\n    background-color: var(--primary);\n    padding: 7px 16px;\n    border-radius: var(--radius-sm);\n    border: none;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 600;\n    color: #fff;\n    transition: all var(--transition-fast);\n}\n\n.uei_edit_button:hover:not(:disabled),\n.uei_confirm_button:hover:not(:disabled) {\n    background-color: var(--primary-hover);\n}\n\n.uei_cancel_button {\n    background-color: var(--bg);\n    padding: 7px 16px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    transition: all var(--transition-fast);\n}\n\n.uei_cancel_button:hover:not(:disabled) {\n    background-color: var(--bg-card);\n    border-color: var(--text-muted);\n}\n\n.uei_edit_button:disabled,\n.uei_confirm_button:disabled,\n.uei_cancel_button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.uei_fields_grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n}\n\n.uei_field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 10px 12px;\n    background-color: var(--bg);\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n}\n\n.uei_field_picture {\n    grid-column: 1 / -1;\n}\n\n.uei_label {\n    font-size: 12px;\n    color: var(--text-muted);\n    font-weight: 500;\n}\n\n.uei_value {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.uei_input {\n    width: 100%;\n    padding: 6px 10px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    font-size: 14px;\n    font-weight: 600;\n    background-color: var(--bg-card);\n    color: var(--text-primary);\n    box-sizing: border-box;\n}\n\n/* Picture upload — same style as UserSignalProvider */\n.uei_picture_row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.uei_picture_preview {\n    width: 72px;\n    height: 72px;\n    object-fit: cover;\n    border-radius: 50%;\n    border: 1px solid var(--border);\n}\n\n.uei_picture_button {\n    padding: 6px 14px;\n    border-radius: var(--radius-sm);\n    border: 1px dashed var(--border);\n    background-color: var(--bg-card);\n    color: var(--text-secondary);\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all var(--transition-fast);\n}\n\n.uei_picture_button:hover {\n    border-color: var(--primary);\n    color: var(--primary);\n    background-color: var(--bg-card);\n}\n\n.uei_picture_filename {\n    font-size: 12px;\n    color: var(--text-muted);\n    font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
